import { Box, Typography } from '@mui/material';
import React from 'react';
import '../../../../css/reportPageHeader.css';

const ReportPageHeader = () => {

    return (
        <Box className='report_headre_main_container'>
            <Box className='report_headre_title_box'>
                <Typography className='report_headre_page_title'>Rapports de contrôle</Typography>
            </Box>
        </Box>

    );
};

export default React.memo(ReportPageHeader);